module.exports = __webpack_public_path__ + "static/10-df5df943744e12a633a4bff421381335.jpg";